import axios from "axios";

import { BASEURL } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";

export function ApiHabibProgress() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
  const url = BASEURL + "habibprogress/";

  return {
    GetSetupHabibProgress: (record) =>
      authAxios.post(url + "GetSetupHabibProgress/", record),
    UpdateSetupHabibProgress: (record) =>
      authAxios.post(url + "UpdateSetupHabibProgress/", record),
    DeleteSetupHabibProgress: (record) =>
      authAxios.post(url + "DeleteSetupHabibProgress/", record),
    AddSetupHabibProgress: (record) =>
      authAxios.post(url + "AddSetupHabibProgress/", record),
    GetAhbabProgressForBoard: (record) =>
      authAxios.post(url + "GetAhbabProgressForBoard/", record),
    AddHabibProgress: (record) =>
      authAxios.post(url + "AddHabibProgress/", record),
    AddHabibProgressComment: (record) =>
      authAxios.post(url + "AddHabibProgressComment/", record),
    GetHabibProgressComments: (record) =>
      authAxios.post(url + "GetHabibProgressComments/", record),
  };
}

export default ApiHabibProgress;
